import { colours } from '../StyleConstants';
import { ComponentsPropsList, Interpolation, Theme } from '@mui/material';

type ButtonVariant = Array<{props: Partial<ComponentsPropsList["MuiButton"]> | ((props: (Partial<ComponentsPropsList["MuiButton"]> & {ownerState: Partial<ComponentsPropsList["MuiButton"]>})) => boolean), style: Interpolation<{theme: Omit<Theme, "components">}>}>;

export const buttonSizes: ButtonVariant = [
    {
        props: { size: "small" },
        style: {
            padding: "8px 16px",
        }
    },
    {
        props: { size: "medium" },
        style: {
            padding: "10px 24px"
        }
    },
    {
        props: { size: "large" },
        style: {
            padding: "12px 24px"
        }
    }
];

export const buttonBaseVariant: ButtonVariant = [
    {
        props: { variant: 'base' },
        style: {
            backgroundColor: colours.gray.gray10,
            color: colours.midnightBlue.blue,
            boarderRadius: "20px",
            "&:hover": { backgroundColor: colours.midnightBlue.blue10 },
        },
    },
]

export const buttonDisabled: ButtonVariant = [
    {
        props: { disabled: true },
        style: {
            backgroundColor: colours.gray.gray10,
            color: colours.gray.gray40,
        }
    },
    {
        props: { variant: 'outlined', disabled: true },
        style: {
            borderColor: colours.gray.gray70,
            backgroundColor: "transparent"
        }
    },
]

export const buttonPrimaryVariant: ButtonVariant = [
    {
        props: { variant: 'primary' },
        style: {
            backgroundColor: colours.orange.orange80,
            color: colours.midnightBlue.blue,
            fontWeight: 600,
            "&:hover": {
                backgroundColor: colours.orange.orange80
            },
            "&:active": {
                backgroundColor: colours.orange.orange
            }
        }
    },
]

export const buttonSecondaryVariant: ButtonVariant = [
    {
        props: { variant: 'secondary' },
        style: {
            backgroundColor: colours.midnightBlue.blue80,
            color: colours.core.white,
            fontWeight: 400,
            "&:hover": {
                boxShadow: "1px 4px 8px 2px rgba(21, 24, 24, 0.25)",
                backgroundColor: colours.midnightBlue.blue80
            },
            "&:active": {
                backgroundColor: colours.midnightBlue.blue
            }
        }
    },
]

export const buttonTertiaryVariant: ButtonVariant = [
    {
        props: { variant: 'tertiary' },
        style: {
            backgroundColor: colours.midnightBlue.blue10,
            color: colours.midnightBlue.blue,
            "&:hover": { backgroundColor: colours.midnightBlue.blue10 },
            "&:active": { backgroundColor: colours.midnightBlue.blue20 },
        }
    },
]

export const buttonOutlinedVariant: ButtonVariant = [
    {
        props: { variant: 'outlined' },
        style: {
            borderWidth: '2px',
            borderColor: colours.midnightBlue.blue,
            "&:hover": {
                backgroundColor: colours.core.white,
                borderColor: colours.midnightBlue.blue,
                borderWidth: '2px',
            },
        }
    },
    {
        props: { variant: 'outlined', color: 'error' },
        style: {
            borderColor: colours.error.error,
            "&:hover": {
                borderColor: colours.error.error,
                borderWidth: '2px',
            },
            "&:active": {
                backgroundColor: colours.error.error,
                color: colours.core.white
            }
        }
    },
    {
        props: { variant: 'outlined', color: 'success' },
        style: {
            borderColor: colours.success.success,
            "&:hover": {
                borderColor: colours.success.success,
                borderWidth: '2px',
            },
            "&:active": {
                backgroundColor: colours.success.success,
                color: colours.core.white
            }
        }
    },
]

export const buttonHighlightVariant: ButtonVariant = [
    {
        props: { variant: 'highlight' },
        style: {
            backgroundColor: colours.orange.orange80,
            fontWeight: 'bold',
            color: colours.midnightBlue.blue,
            "&:hover": { backgroundColor: colours.midnightBlue.blue10 },
            '&:disabled': { backgroundColor: colours.gray.gray20 }
        },
    },
]